var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('package-form',{attrs:{"loading":_vm.loading,"packData":_vm.pack,"formErrors":_vm.formErrors},on:{"packSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }